// eslint-disable-next-line import/prefer-default-export
export const ManualTypeOptions = [
  { label: "Generic", value: "0" },
  { label: "Generic 50 mm", value: "1" },
  { label: "Assembly", value: "2"}
];
